import "./App.css";
import Loading from "./components/uikit/atoms/Loading";
import { useRecoilState } from "recoil";
import { userState } from "./states/userState";
import { useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "./commons/theme";
import Router from "./router/Router";
import { BrowserRouter } from "react-router-dom";

function App() {
  const [user, setUser] = useRecoilState(userState);

  useEffect(() => {
    console.log("App:user", user, user.isAuth);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Loading>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </Loading>
    </ThemeProvider>
  );
}

export default App;
